export default __webpack_public_path__ + "static/media/Sodexo.37d15979.svg";